import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@m/ui/cn';

/** A labelled text field row inside a Group: label left, input right. */
export function FieldRow({ label, className, ...input }: { label: ReactNode } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className="flex min-h-[52px] items-center gap-3 px-4">
      <span className="shrink-0 text-body">{label}</span>
      <input
        {...input}
        className={cn('min-w-0 flex-1 bg-transparent text-right text-body text-[var(--text-muted)] outline-none placeholder:text-[var(--text-subtle)] focus:text-[var(--text)]', className)}
      />
    </label>
  );
}

/** A full-width text input row (free text gets its own row). */
export function TextRow(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className="h-[52px] w-full bg-transparent px-4 text-body outline-none placeholder:text-[var(--text-subtle)]"
    />
  );
}
